import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  console.log('🛡️ ProtectedRoute: Check -', { isLoading, isAuthenticated });

  if (isLoading) {
    console.log('⏳ ProtectedRoute: Still loading, showing spinner');
    // Show loading spinner while checking auth
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1f2e 0%, #2d1b3d 100%)'
      }}>
        <div style={{
          textAlign: 'center',
          color: '#E0E6F0'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '16px'
          }}>
            🔄
          </div>
          <div style={{
            fontSize: '1.25rem',
            fontFamily: 'Rajdhani, sans-serif',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.1em'
          }}>
            Loading...
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('🚫 ProtectedRoute: Not authenticated, redirecting to /login');
    // Not authenticated, redirect to login
    return <Navigate to="/login" replace />;
  }

  console.log('✅ ProtectedRoute: Authenticated, rendering protected content');
  // Authenticated, render the protected content
  return <>{children}</>;
}
